<template>
  <div class="password_box">
    <h2 class="title">{{ $t('key1006544') }}</h2>
    <Steps :current="current">
      <Step :title="$t('key1005485')"></Step>
      <Step :title="$t('key1006559')"></Step>
      <Step :title="$t('key1003254')"></Step>
    </Steps>
    <Form ref="passwordForm" :rules="passwordRuleValidate" :model="passwordForm" class="passwordForm" @submit.native.prevent>
      <!--验证身份-->
      <Form-item prop="emailOrMobile" v-if="current === 0">
        <Input :placeholder="$t('key1006560')" clearable v-model.trim="passwordForm.emailOrMobile">
          <Select slot="prepend" v-model="passwordForm.mobileCountryCode" filterable transfer class="reset_select_input">
            <Option v-for="(item, index) in countrysData" :value="item.areaCode" :key="index">{{ item.areaCodeName }}</Option>
          </Select>
        </Input>
      </Form-item>
      <FormItem prop="verificationCode" v-if="current === 0">
        <div class="verificationcode_box">
          <Input type="text" clearable v-model.trim="passwordForm.verificationCode" :placeholder="$t('key1001002')"></Input>
          <img :alt="$t('key1001003')" width="110" height="40" :src="captchaImage" @click="getCaptcha"/>
        </div>
      </FormItem>
      <FormItem prop="code" v-if="current === 0">
        <div class="verificationcode_box">
          <Input type="text" clearable v-model.trim="passwordForm.code" :placeholder="$t('key1001004')"></Input>
          <Button size="large" class="code_btn" @click="sendVerificationCode" :disabled="talgCode">{{ codeText }}</Button>
        </div>
      </FormItem>
      <!--设置密码-->
      <Form-item prop="password" v-if="current === 1">
        <Input type="password" clearable :placeholder="$t('key1001005')" v-model.trim="passwordForm.password"></Input>
      </Form-item>
      <Form-item prop="password1" v-if="current === 1">
        <Input type="password" :placeholder="$t('key1001006')" v-model.trim="passwordForm.password1"></Input>
      </Form-item>
      <!--设置成功-->
      <div class="setting_box" v-if="current === 2">
        <i class="iconfont setting-icon">&#xe614;</i>
        <p class="txt">{{ $t('key1003254') }}</p>
      </div>
      <Button v-if="current === 0 || current === 1" type="primary" style="width: 100%" size="large" @click="nextStepBtn">{{ queryTxt }}</Button>
      <Button v-if="current === 2" size="large" class="code_btn" style="width: 94px; margin: 0 auto;" @click="toLogin">{{ $t('key1006561') }}</Button>
    </Form>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {getAllCountrysData} from "@/utils/common";


export default {
  name: "password",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      current: 0,
      talgCode: false,
      codeText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000988'),
      passwordForm: {
        emailOrMobile: '',
        verificationCode: '',
        code: '',
        password: '',
        password1: '',
        mobileCountryCode: '86'
      },
      passwordRuleValidate: {
        emailOrMobile: [
          {
            required: true,
            validator: v.validateEmailOrMobile(),
            trigger: 'blur'
          }
        ],
        verificationCode: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000989'),
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000990'),
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000143'),
            trigger: 'blur'
          }
        ],
        password1: [
          {
            validator: v.validatenewPassword(),
            required: true,
            trigger: 'blur'
          }
        ],
      },
      queryTxt: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002560'),
      captchaImage: '',
      userId: null,
      uid: '',
      countrysData: []
    };
  },
  created() {
    getAllCountrysData('en').then((data) => {
      // 默认为中国手机号 +86
      this.passwordForm.mobileCountryCode = '86';
      this.countrysData = data;
    });
    this.getCaptcha();
  },
  methods: {
    // 校验手机号/邮箱
    validateEmailOrMobile() {
      let v = this;
      let isMob = v.$regular.isPhone;
      let isMailbox = v.$regular.isMailbox;
      let mobile = function (rule, value, callback) {
        if (!value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006556')));
        } else if (!(isMob.test(value) || isMailbox.test(value))) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002697')));
        } else {
          callback();
        }
        callback();
      };
      return mobile;
    },
    // 校验新密码与旧密码
    validatenewPassword() {
      let v = this;
      let password = function (rule, value, callback) {
        if (!value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006557')));
        } else if (v.passwordForm.password !== value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000998')));
        } else {
          callback();
        }
      };
      return password;
    },
    // 登录
    toLogin() {
      let talg = window.location.href.split('//');
      let url = '/index.html#/index';
      let link = '';
      if (talg[1].includes('localhost')) {
        link = `${talg[0]}//${window.location.host}${url}`;
      } else {
        link = `${'/yms-shopping-service' + url}`;
      }
      this.$router.push({
        path: '/login',
        query: {
          u: link
        }
      });
    },
    // 发送手机验证码
    sendVerificationCode() {
      let v = this;
      let talg = false;
      v.$refs.passwordForm.validateField("emailOrMobile", (error) => {
        if (!error) {
          v.$refs.passwordForm.validateField("verificationCode", (error) => {
            if (!error) {
              talg = true;
            }
          });
        }
      });
      if (talg) {
        let query = {
          code: v.passwordForm.verificationCode, // 图片的验证码
          isvalid: 1, // 1 校验图片验证码  0 不校验
          messageType: 2, //  类型 1 注册 2 找回密码 3 绑定手机 4找回邮箱 5 登录   15 海外-找回密码
          isValidHasRegistry: 1, // 校验手机号/邮箱是否注册过  1 校验  0 不校验
          mobile: v.passwordForm.mobile,
          uid: this.uid
        };
        let isPhone = v.$regular.isPhone;
        let isMailbox = v.$regular.isMailbox;
        let url = '';
        let value = v.passwordForm.emailOrMobile;
        if (isPhone.test(value)) {
          url = api.post_ymsUserSetting_sendMobileVerificationCode;
          query.mobile = value;
          query.mobileCountryCode = v.passwordForm.mobileCountryCode;
          query.messageType = v.passwordForm.mobileCountryCode === '86' ? 2 : 15;
        } else if (isMailbox.test(value)) {
          url = api.post_ymsUserSetting_sendEmailVerificationCode;
          query.email = value;
        }
        v.talgCode = true;
        v.axios.post(url, query).then(response => {
          if (response.data.code === 0) {
            this.getCaptcha();
            let time = 60;
            let timeStop = setInterval(() => {
              time--;
              if (time > 0) {
                v.codeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000995') + time + 'S';
                v.talgCode = true;
              } else {
                time = 60;
                v.codeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000988');
                clearInterval(timeStop); //清除定时器
                v.talgCode = false;
              }
            }, 1000);
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005483'));
          } else {
            v.talgCode = false;
          }
        });
      }
    },
    // 下一步
    nextStepBtn() {
      let v = this;
      // 验证身份
      if (v.current === 0) {
        v.$refs.passwordForm.validateField("emailOrMobile", (error) => {
          if (!error) {
            v.$refs.passwordForm.validateField("verificationCode", (error) => {
              if (!error) {
                v.$refs.passwordForm.validateField("code", (error) => {
                  if (!error) {
                    let query = {
                      emailOrMobile: v.passwordForm.emailOrMobile,
                      code: v.passwordForm.code,
                      mobileCountryCode: v.passwordForm.mobileCountryCode,
                      messageType: v.passwordForm.mobileCountryCode === '86' ? 2 : 15 // 类型 1 注册 2 找回密码 3 绑定手机 4找回邮箱 5 登录 15 海外-找回密码
                    };
                    v.axios.post(api.post_ymsUserSetting_validVerificationCode, query).then(response => {
                      if (response.data.code === 0) {
                        v.userId = response.data.datas;
                        v.current += 1;
                        v.queryTxt = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006558');
                      } else {
                        v.passwordForm.code = '';
                        v.passwordForm.verificationCode = '';
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
      // 设置密码
      if (v.current === 1) {
        v.$refs.passwordForm.validateField("password", (error) => {
          if (!error) {
            v.$refs.passwordForm.validateField("password1", (error) => {
              if (!error) {
                let value = v.passwordForm.emailOrMobile;
                let isPhone = v.$regular.isPhone;
                let isMailbox = v.$regular.isMailbox;
                let query = {
                  emailOrMobile: value,
                  password: v.passwordForm.password,
                  userId: v.userId
                };
                if (isPhone.test(value)) {
                  query.type = 'mobile';
                } else if (isMailbox.test(value)) {
                  query.type = 'email';
                }
                v.axios.put(api.put_ymsUserSetting_settingPassword, query).then(response => {
                  if (response.data.code === 0) {
                    v.current += 1;
                  }
                });
              }
            });
          }
        });
      }
    },
    // 获取图片验证码
    getCaptcha() {
      // 获取当前的时间戳
      this.axios.get(api.yms_get_captcha).then((response) => {
        this.captchaImage = 'data:image/png;base64,' + response.data.datas.base64ImageCode;
        this.uid = response.data.datas.uid;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.password_box {
  width: 600px;
  padding-top: 40px;
  margin: 0 auto;
  min-height: 800px;

  .title {
    color: #2E3E51;
    font-size: 28px;
    text-align: center;
  }

  /deep/ .ivu-steps {
    margin: 60px auto 40px;

    .ivu-steps-tail > i:after {
      left: 2px;
    }

    .ivu-steps-item {
      display: flex;
    }
  }

  .passwordForm {
    padding: 0 120px;

    /deep/ .ivu-form-item {
      input {
        height: 40px;
        line-height: 40px;
      }

      .verificationcode_box {
        display: flex;
        justify-content: space-between;
        align-items: center;

        input {
          width: 235px;
        }

        img {
          cursor: pointer;
        }
      }
    }

    .setting_box {
      margin: 40px auto 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .setting-icon {
        color: #28BD6E;
        font-size: 38px;
      }

      .txt {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: bolder;
        color: #000000;
      }
    }
  }

  .code_btn {
    display: block;
    width: 157px;
    padding: 0;
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-size: 13px;
    background: #fff;
    color: #fd5425;
    border: solid 1px #fd5425;
    border-radius: 4px !important;

    &:hover {
      color: #fff;
      background: #fd5425;
      border-color: #fd5425;
    }
  }

  /deep/ .reset_select_input {
    width: 120px;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;

    .ivu-select-selection {
      height: 40px;
    }
  }

  /deep/ .ivu-input-group-prepend {
    background-color: transparent;
  }
}
</style>
